import Medusa from '@medusajs/medusa-js'
import { Cart } from '@miles/domain/Store/Models/Cart/Cart'
import { CartParseService } from '@miles/domain/Store/Services/Cart/CartParseService'
import { IFrontCartService } from 'domain/application/services/cart/FrontCartService'
import { getFromLocalStorage } from 'services/localStorage/getOrSetLocalStorage'
import { storefrontApiClient } from 'store/clients/storefrontApiClient'
import { KEY_CART_IN_LOCALSTORAGE } from 'store/constants'

export class LiveFrontCartService implements IFrontCartService {
  constructor(private medusaClient: Medusa) {}

  async checkoutCart(): Promise<Cart> {
    const cartIdFromLocalStorage = getFromLocalStorage(KEY_CART_IN_LOCALSTORAGE)
    return cartIdFromLocalStorage
      ? await this.getCart(cartIdFromLocalStorage)
      : await this.createCart()
  }

  async appCart(): Promise<Cart | null> {
    const cartIdFromLocalStorage = getFromLocalStorage(KEY_CART_IN_LOCALSTORAGE)
    return cartIdFromLocalStorage
      ? await this.getCart(cartIdFromLocalStorage)
      : null
  }

  dashboardCart(): null {
    return null
  }

  private async createCart(): Promise<Cart> {
    const cart = (await this.medusaClient.carts.create()).cart

    return CartParseService.parseCart(cart)
  }

  private async getCart(cartId: string): Promise<Cart> {
    return storefrontApiClient.getCartById(cartId)
  }
}
